/**
 * @generated SignedSource<<783f8692788603f1e597864d05b11edb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeScreen_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "HomeScreen_session";
};
export type HomeScreen_session$key = {
  readonly " $data"?: HomeScreen_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeScreen_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeScreen_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Member",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "e30705c3ba956b8fdcf6752d46ef811a";

export default node;
